import React, { useEffect, useState } from "react";
import { Formik, Form } from 'formik';
import swal from "sweetalert2";
import { useHistory } from "react-router";

import { MyTextInput, MySelect } from '../../components'
import { postPisoEdificio } from '../../apis/PisosAPI';
import { validationNuevoPiso } from "./validations";
import { useAbmStyles } from "./styles";
import { getAllEdificios } from "../../apis/EdificiosAPI";
import { DefaultLayout } from "./container/DefaultLayout";
import '../../styles/styles.css';
import { usePermisosUsuario } from "../../hooks/usePermisosUsuario";


export const NuevoPisoEdificio = (props) => {
    usePermisosUsuario([4])
    let history = useHistory()
    return (
        <DefaultLayout
            urlBack='/Pisos'
            title='Nuevo Piso Edificio'
        >
            <NuevoPisoEdificioForm
                onClose={() => { history.push('/Abms/Pisos/Edificio')}}
            />
        </DefaultLayout>

    )
}

export const NuevoPisoEdificioForm = ({
    idEdificio = '',
    onClose = () => { }
}) => {
    const [loading, setLoading] = useState(true)
    const classes = useAbmStyles();
    const [edificios, setEdificios] = useState([])

    useEffect(() => {
        setLoading(true);
        cargarEdificios();
    }, []);

    function cargarEdificios() {
        getAllEdificios()
            .then(res => {
                if (res?.data) {
                    setEdificios(res?.data);
                }
            })
        setLoading(false);
    }

    function submit(data) {
        postPisoEdificio(data)
            .then(res => {
                if (res?.data?.status === 400) {
                    swal
                        .fire({
                            title: "Error",
                            text: "No se ha podido crear el Piso!",
                            icon: "warning",
                            confirmButtonColor: "#009bdb",
                            confirmButtonText: "OK",
                            animation: true,
                        })
                } else {
                    swal
                        .fire({
                            title: 'OK',
                            text: 'Se ha creado el Piso correctamente.',
                            icon: "success",
                            showConfirmButton: false,
                            animation: true,
                            timer: 4000
                        })
                }
            })

        onClose()
        setLoading(false);
    }

    return (
        <Formik
            initialValues={{
                Nombre: '',
                Numero: '',
                idEdificio: idEdificio
            }}
            onSubmit={(values) => {
                submit(values)
            }}
            validationSchema={validationNuevoPiso}>

            {(formik) => (
                <Form>
                    <MyTextInput
                        label="Nombre"
                        name="Nombre"
                        placeholder="ingresar un nombre..."
                    />

                    <MyTextInput
                        label="Numero"
                        name="Numero"
                        placeholder="ingresar una Numero..."
                        type='number'
                    />

                    <MySelect label="Edificio" name="idEdificio" >
                        <option value="">Seleccionar...</option>
                        {edificios && edificios.map(e => {
                            return <option key={e.id} value={e.id}>{e.nombre}</option>
                        })}
                    </MySelect>

                    <button type="submit" className={classes.btn} disabled={loading}>Submit</button>

                </Form>
            )
            }
        </Formik>

    )
}

